
<div style="position: relative">
    <d-site
        v-model  = "unit.show"
        :site-id = "unit.id"
    />

    <c-card-iterator
        header-color   = "secondary"
        :title-border   = "true"
        :items          = "filteredItems"
        :label          = "title"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "76"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "72"
        :height         = "height"
        @search         = "onSearch"
    >
        <template v-slot:card="{ item }">
            <p-lgs-card
                :event = "item"
                @unit = "onUnit"
            />
        </template>
    </c-card-iterator>
    <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
        <v-icon color="success" size="30">mdi-check-circle</v-icon>
    </div>
</div>
